import { Component } from '@angular/core';
import { soundpostProcessingBatchEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';
import {  } from "@memberjunction/ng-entity-viewer"

@RegisterClass(BaseFormComponent, 'Processing Batches') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-soundpostprocessingbatch-form',
    templateUrl: './soundpostprocessingbatch.form.component.html'
})
export class soundpostProcessingBatchFormComponent extends BaseFormComponent {
    public record!: soundpostProcessingBatchEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true },
            { sectionKey: 'processingErrors', sectionName: 'Processing Errors', isExpanded: false }
        ]);
    }
}

